(function () {
  const fastSimonSortBy = {
    Featured: 'relevancy',
    Popularity: "popularity",
    AtoZ: "a_to_z",
    ZtoA: "z_to_a",
    PriceLowToHigh: "price_min_to_max",
    PriceHighToLow: "price_max_to_min",
    OldFirst: "creation_date_oldest",
    NewFirst: "creation_date",
  }

  const { collection, settings } = $("#collection-main").data() || {}
  const params = new URLSearchParams(window.location.search)
  let defaultSort = ["new"].includes(collection.handle) ? fastSimonSortBy?.Featured || 'creation_date' : fastSimonSortBy?.Popularity || 'popularity'
  if (collection.handle === "mags") {
    defaultSort = fastSimonSortBy.Featured
  }
  const basicParams = {
    UUID:'f7409c9d-d2ae-4ac8-948f-431d083aa04d',
    store_id:12487893,
  }
  const state = {
    loading: false,
    sortBy: params.get('sortby') ? params.get('sortby') : defaultSort,
    collapsedByDefault: settings.collapsedByDefault || true,
    cdnCacheKey: '',
    paginate: {
      products_per_page: settings.products_per_page || 100,
      page_num: 1
    },
    range: [],
    defaultFacets: null,
    selectedfilters: [],
    lastOpened: [],
    lastStoredProducts: {
      items:[]
    }
  }
  function getUrlPayload(fr=1) {
    return {
      q: params.get('q'),
      facets_required: fr,
      narrow: JSON.stringify(state.selectedfilters),
      sort_by: state.sortBy,
      cdn_cache_key: state.cdnCacheKey,
      category_id: collection?.id || 386594631,
      with_product_attributes: true,
      ...state.paginate,
      ...basicParams,
    }
  }
  async function initialization() {
    try {
      const url = new URLSearchParams(basicParams)
      const { cdn_cache_key } = await fetch('https://api.instantsearchplus.com/load?'+ url.toString()).then(res=> res.json())
      state.cdnCacheKey = cdn_cache_key || null
      return cdn_cache_key
    } catch (error) {
      return null
    }
  }
  async function fetchFacets(init = true) {
    state.paginate.page_num = 1
    $('.collection-filters-drawer-element').addClass('is-loading')
    $('.apply-filters-wrapper').addClass('is-loading')
    $('.apply-filters-wrapper').removeClass('disabled')
    try {
      const url = new URLSearchParams(getUrlPayload(2))
      const res = await fetch('https://api.instantsearchplus.com/categories_navigation?'+ url).then(res=> res.json())
      if (res) {
        // $('.apply-filters-wrapper a').html(`VIEW RESULTS`)
        !state.defaultFacets && rangeSlider(res.facets)
        handleMissingFilters(res.facets)
        const transformedFacets = facetsTransformer(res.facets);
        if (transformedFacets.length === 0) {
          $('.collection-filter-top-page').addClass('disabled')
          // $('.collection__main').html('')
          // $('.collection-top-filter').html(`<span class="no-filter-match">No products match your filter criteria</span>`)
        }
        generateFacets(transformedFacets, init)
      }
      return res
    } catch {
      return null
    } finally{
      $('.apply-filters-wrapper').removeClass('is-loading')
      $('.collection-filters-drawer-element').removeClass('is-loading')
      $('.apply-filters-wrapper').removeClass('is-loading')
    }
  }
  async function fetchProducts(props= {loadmore: false}) {
    !props.loadmore && (state.paginate.page_num = 1)
    $('.placeholders').addClass('is-loading')
    $('.apply-filters-wrapper').addClass('is-loading')
    !props.loadmore && $('.collection-grid-products').html('')

    try {
      const url = new URLSearchParams(getUrlPayload())
      const res = await fetch('https://api.instantsearchplus.com/full_text_search?'+ url).then(res=> res.json())
      if (res) {
        state.lastStoredProducts = res
        res.total_p === res.p ? $('.reach-end').css("display", 'none') : $('.reach-end').css("display", 'block')
        // $('.collection__title').text('Search: ' + res.total_results + ' results found for "' + url.get('q') + '"')
        $('#result-number').text(res.total_results + ' items')
        generateProducts(res.items)
      }
      return res
    } catch {
      return null
    } finally {
      $('.placeholders').removeClass('is-loading')
      $('.apply-filters-wrapper').removeClass('is-loading')
    }
  }

  /**
   * 
   * @returns {void}
   */
  // function initParams(name) {
  //   (params.getAll(name) || []).forEach(value => {
  //     state.selectedfilters.push([name, value])
  //   })
  // }
  /**
   * 
   * @returns {void}
   */
   function debounce(func, timeout = 800){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }


  /**
   * 
   * @returns {void}
   */
  //  function queryBuilder() {
  //   let url = `?sortby=${state.sortBy}`
  //   state.selectedfilters.forEach(filter => {
  //     url += `&${filter[0]}=${filter[1]}`
  //   })
  //   window.history.replaceState({}, '', url)
  // }


  /**
   * 
   * @returns {void}
   */
  function initSortBy() {
    const labels = {
      Featured: 'Featured',
      Popularity: "Best Selling",
      AtoZ: "Alphabetically, A-Z",
      ZtoA: "Alphabetically, Z-A",
      PriceHighToLow: "Price, high to low",
      PriceLowToHigh: "Price, low to high",
      NewFirst: "Date, new to old",
      OldFirst: "Date, old to new"
    }
    for (const key in fastSimonSortBy) {
      const value = fastSimonSortBy[key];
      const label = labels[key]
      const isChecked = state.sortBy === value
      isChecked && $('#selected-option span').text('Sort by: ' + label)
      $('.list-of-option')?.append(`<li class='sortby-${key} ${isChecked ? 'active' : ''}'>
        <input type="radio" value="${value}" name="label_name" ${isChecked ? 'checked' : ''} data-text="${label}" id="${key}" class="sort-by-value sort-${value}" >
        <label for="${key}">${label}</label>
      </li>`);
    }

    $('.sort-by-value').change(function () {
      state.sortBy = $(this).val()
      $('#selected-option span').text('Sort by: ' + $(this).data()?.text) ///= sort.getAttribute('data-text')
      $('.sort-by-value').closest('li').removeClass('active')
      $(this).closest('li').addClass('active')
      closeDrawer()
      $(".collection-grid-products").html('')
      // $('.placeholders').addClass('is-loading')
      fetchProducts()
    })
  }


  /**
   * remove facest that didn't have products and didn't fetched from facets call but already axist on our state
   * @param {facets} facets 
   */
   function handleMissingFilters(facets) {
    state.selectedfilters = state.selectedfilters.filter(selectedValue=> {
      if (selectedValue[0].includes('Price')) {
        return true
      }
      return facets.some(facet=>{
        if (facet[0].includes('Price') || facet[0].includes('Tag') ) return false;
        let isExist = false
        facet[1].forEach(value=>{
          if (JSON.stringify(selectedValue) === JSON.stringify([facet[0], value[0]])) {
            isExist = true
          }
        })
        return isExist
      })
    })
  }

  function facetsTransformer(facets) {
    !state.defaultFacets && (state.defaultFacets = facets)
    return state.defaultFacets.map(selectedValue => {
      const filterType = selectedValue[0]
      //const filterType = selectedValue[2]
      const filterValues = selectedValue[1]
      const facest1 = facets.find(f=> f[0] === filterType)
      const mappedValues = filterValues.map(value=>{
        const selected = state.selectedfilters.some(v => JSON.stringify(v) === JSON.stringify([filterType, value[0]]))
        const newValue = {
          name: value[0],
          count: 0,
          selected
        }
        if (facest1) {
          const valueToFind = facest1[1].find(v=> v[0] === value[0])
          valueToFind && (newValue.count = valueToFind[1])
        }
        return newValue
      })
      return [filterType, mappedValues]
    })
  }

  /**
   * 
   * @returns {void}
   */
  function rangeSlider(facets) {
    const [_1, min] = facets.find(f=> f[0] === 'Price_min') || []
    const [_2, max] = facets.find(f=> f[0] === 'Price_max') || []
    function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
      const [from, to] = getParsed(fromInput, toInput);
      fillSlider(fromInput, toInput, '#000', '#000', controlSlider);
      if (from > to) {
        fromSlider.value = to;
        fromInput.value = to;
      } else {
        fromSlider.value = from;
      }
    }
      
    function controlToInput(toSlider, fromInput, toInput, controlSlider) {
      const [from, to] = getParsed(fromInput, toInput);
      fillSlider(fromInput, toInput, '#000', '#000', controlSlider);
      setToggleAccessible(toInput);
      if (from <= to) {
        toSlider.value = to;
        toInput.value = to;
      } else {
        toInput.value = from;
      }
    }
  
    function controlFromSlider(fromSlider, toSlider, fromInput) {
      const [from, to] = getParsed(fromSlider, toSlider);
      fillSlider(fromSlider, toSlider, '#000', '#000', toSlider);
      if (from > to) {
        fromSlider.value = to;
        fromInput.value = to;
      } else {
        fromInput.value = from;
      }
    }
    
    function controlToSlider(fromSlider, toSlider, toInput) {
      const [from, to] = getParsed(fromSlider, toSlider);
      fillSlider(fromSlider, toSlider, '#000', '#000', toSlider);
      setToggleAccessible(toSlider);
      if (from <= to) {
        toSlider.value = to;
        toInput.value = to;
      } else {
        toInput.value = from;
        toSlider.value = from;
      }
    }

    function getParsed(currentFrom, currentTo) {
      const from = parseInt(currentFrom.value, 10);
      const to = parseInt(currentTo.value, 10);
      return [from, to];
    }
      
    function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
      const rangeDistance = to.max-to.min;
      const fromPosition = from.value - to.min;
      const toPosition = to.value - to.min;
      controlSlider.style.background = `linear-gradient(
        to right,
        #000 0%,
        #000 ${(fromPosition)/(rangeDistance)*100}%,
        ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%,
        ${rangeColor} ${(toPosition)/(rangeDistance)*100}%, 
        #000 ${(toPosition)/(rangeDistance)*100}%, 
        #000 100%)`;
    }
    
    function setToggleAccessible(currentTarget) {
      const toSlider = document.querySelector('#toSlider');
      if (Number(currentTarget.value) <= 0 ) {
        toSlider.style.zIndex = 2;
      } else {
        toSlider.style.zIndex = 0;
      }
    }
    
    const fromSlider = document.querySelector('#fromSlider');
    const toSlider = document.querySelector('#toSlider');
    const fromInput = document.querySelector('#fromInput');
    const toInput = document.querySelector('#toInput');

    fromSlider.max = max
    fromSlider.min = min
    fromSlider.value = min

    toSlider.max = max
    toSlider.min = min
    toSlider.value = max

    fromInput.min = min
    fromInput.max = max
    toInput.min = min
    toInput.max = max
    fromInput.value = min
    toInput.value = max
    const setSelectedValue = debounce((fetch = true) => {
      state.range = [fromSlider.value, toSlider.value]
      state.selectedfilters = state.selectedfilters.filter(v => v[0] !== 'Price_from_to')
      const priceRange = ['Price_from_to', state.range.join('-')]
      state.selectedfilters.push(priceRange)
      fetch && fetchFacets()
    })
    fillSlider(fromSlider, toSlider, '#000', '#000', toSlider);
    setToggleAccessible(toSlider);
    
    fromSlider.oninput = () => {
      controlFromSlider(fromSlider, toSlider, fromInput)
      setSelectedValue()
    };
    toSlider.oninput = () => {
      controlToSlider(fromSlider, toSlider, toInput)
      setSelectedValue()
    };
    fromInput.oninput = () => {
      controlFromInput(fromSlider, fromInput, toInput, toSlider)
      setSelectedValue()
    };
    toInput.oninput = () => {
      controlToInput(toSlider, fromInput, toInput, toSlider)
      setSelectedValue()
    };
  }

  /**
   * 
   * @param {ProductObject} products 
   * @returns {void}
   */
  function generateProducts(products) {
    let containerProducts = document.querySelector(".collection-grid")
    let divContainer = document.createDocumentFragment()
    products.forEach(result => {
      if(result.id != "2328750653517"){
      if (result.v === "ConvoyOP") return;
      const Tags = result?.att?.find(v=> v[0] === 'Tag')
      if (Tags)
      for (let i = 0; i < Tags[1].length; i++) {
        if (Tags[1][i].startsWith('brand-')) {
          let isInSelected = state.selectedfilters.some(v=> v[0]=== "tag_filter_0.464" && v[1] === (Tags[1][i]))
          if (isInSelected) {
            result.v = Tags[1][i].replace('brand-', '').replaceAll('-', ' ')
          } else {
            result.v = Tags[1][i].replace('brand-', '').replaceAll('-', ' ')
          }
        }
      }
        let pricing = ""
        if (Number(result.p_c) > 0) {
          pricing = `
            <span class="product-thumbnail__price price sale">
              <span class="money">
                ${Shopify.formatMoney(Number((result.p || 0) * 100))}
              </span>
              <span class="product-thumbnail__was-price compare-at-price">
                <span class="money">
                  ${Shopify.formatMoney((result.p_c || 0) * 100)}
                </span>
              </span>
            </span>
          `
        } else {
          pricing = `
            <span class="product-thumbnail__price price">
              <span class="money">
                ${Shopify.formatMoney(Number((result.p || 0) * 100))}
              </span>
            </span>
          `
        }

        let divItem = document.createElement('div')
        
        divItem.className = `product-${result.id} js-product_section has-thumbnail-sticker thumbnail product__thumbnail product__grid-item thumbnail__hover-overlay--false`
        divItem.dataset.product_id = result.id
        let productUrl =  `/collections/${collection.handle + result.u}`
        let newTitle = result.l;
        let imgSrc = !result.t2.includes("instantsearchplus.com") ? result.t2 : result.t
          
        divItem.innerHTML = `
            <div class="wishlist-link-collection" data-product-id="${result.id}"></div>
            <div class="product-wrap">
              <div class="product-image__wrapper">
                <div class="image__container product__imageContainer">
                <a href="${productUrl}">
                  <div class="sticker-holder sticker-shape-square sticker-position-bottom-left">
                    <div class="sticker-holder__content sticker-holder__content--product">
                      <div class="new-sticker thumbnail-sticker sticker-">
                        <span class="sticker-text">New</span>
                      </div>
                    </div>
                  </div>
                  <div class="image-element__wrap" style=" max-width: 600px;">
                    <img alt="${result.l}" class="transition--fade-in lazyautosizes lazyloaded" sizes="252px" loading="lazy" src="${imgSrc}">
                  </div>
                </a>
              </div>
              <div class="thumbnail__caption text-align-left">
                <div class="product-thumbnail collection-area">
                  <a href="${productUrl}" class="product-thumbnail__title">
                    ${newTitle}
                  </a>
                  <span class="product-thumbnail__vendor">
                    ${result.v}
                  </span>
                  ${pricing}
                </div>
              </div>
            </div>`
        divContainer.appendChild(divItem) 
      }
    })

    containerProducts.appendChild(divContainer)
    state.loading = false
    if (!products.length && containerProducts.childNodes.length === 0) {
      containerProducts.innerHTML = "<div class='no-results-collection'><p>Sorry we couldn't find any matching <b id='replace-text'></b></p></div>"
      document.getElementById('replace-text').textContent = params.get('q') ? params.get('q') : ""
      document.querySelector(".collection-grid").classList.add("empty-results")
      document.querySelector('.reach-end').style.display = 'none'
      document.querySelector('.collection-filters-toggle').classList.add('disabled')
    } else {
      document.querySelector(".collection-grid").classList.remove("empty-results")
      document.querySelector('.reach-end').style.display = 'block'
      document.querySelector('.collection-filters-toggle').classList.remove('disabled')
    }
    initActiveFilters()
  }

  /**
   * 
   * @param {FacetsObject} facets 
   * @returns {void}
   */
  function generateFacets(facets, init) {
    $('.collection-filters-drawer-facets').html('')
    let content = ''
    facets.forEach(facet => {
      const name = facet[0]?.toLowerCase()
      const values = facet[1]        
      init && !state.collapsedByDefault && state.lastOpened.push(name)
      if (name.includes('price') || name.includes('global.display vendor')) return;
      const isCollapsed = state.lastOpened.includes(name)
      const selectedFace = state.selectedfilters.reduce((total, v) => (v[0] === facet[0] ? total + 1 : total), 0)
      let items = ``
      values.forEach(value => {
        if (name === "color" || name === "colors" || name === "lights color" || name === "print color") {
          items += `
            <li title=" ${value.name.replaceAll('-', ' ').replace('/ ', '/')}" class="collection-container ${value.count === 0 ? 'disabled-filter' : ''} filter-active-color-${value.name?.toLowerCase()?.replace(' ', '-')} filter-color">
              <div class="collection-name color-option">
                <input type="checkbox" id="${name + value.name}" ${value.selected ? 'checked' : ''} ${value.count === 0 ? 'disabled' : ''} data-name="${facet[0]}"  data-value="${value.name}">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6.751" viewBox="0 0 9 6.751">
                  <path id="Path_13233" data-name="Path 13233" d="M28.748,35.528,26.5,33.279,25.372,34.4l3.376,3.376,5.625-5.625-1.124-1.126Z" transform="translate(-25.372 -31.028)"/>
                </svg>
                <label class="value-label ${ value.selected ? 'active-label' : ''}" for="${name + value.name}">
                  ${value.name}
                </label>
              </div>
            </li>
          `
        } else {
          items += `
            <li class="collection-container ${value.count === 0 ? 'disabled-filter' : ''} ${value.selected ? 'checked' : ''}">
              <div class="collection-name is-flex">
                <input type="checkbox" id="${name + value.name}" ${value.selected ? 'checked' : ''} ${value.count === 0 ? 'disabled' : ''} data-name="${facet[0]}"  data-value="${value.name}">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6.751" viewBox="0 0 9 6.751">
                  <path id="Path_13233" data-name="Path 13233" d="M28.748,35.528,26.5,33.279,25.372,34.4l3.376,3.376,5.625-5.625-1.124-1.126Z" transform="translate(-25.372 -31.028)"/>
                </svg>
                <label class="value-label" for="${name + value.name}" filter-data="${value.name}">
                  <div>${value.name.replace('brand-', '').replaceAll('-', ' ')}</div>
                </label>
              </div>
            </li>
          `
        }
      })
      content += `
        <div class="filter-group filter-group-${name === 'tag_filter_0.464' ? 'brand' : name}">
          <div class="filter-group-header ${isCollapsed ? 'is-open' : ''}" data-name="${name}">
            <h4>${name === 'tag_filter_0.464' ? 'Brand': name}<span class="filtered-count ${selectedFace > 0 ? 'active' : ''}">(${selectedFace})</span></h4>
            <div class="filter-group-flex">
              <span id="filtred-by-${name}" class="filter-group-clear ${selectedFace > 0 ? 'active' : ''}">Clear</span>
              <span class="filter-group-toggler" id="filter-group-toggler-plus">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="19" viewBox="0 0 8 19">
                  <text id="_" data-name="+" transform="translate(8 15)" font-size="14" font-family="Roboto-Regular, Roboto" letter-spacing="0.025em"><tspan x="-7.937" y="0">+</tspan></text>
                </svg>
              </span>
              <span class="filter-group-toggler" id="filter-group-toggler-minus">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 11 19">
                  <text id="_" data-name="—" transform="translate(11 15)" font-size="14" font-family="Roboto-Regular, Roboto" letter-spacing="0.025em"><tspan x="-10.931" y="0">—</tspan></text>
                </svg>
              </span>
            </div>
          </div>
          <div class="scroll-content ${isCollapsed ? 'shown' : ''}">
            <ul class="nav-${name} nav-filter-item">${items}</ul>
          </div>
        </div>
      `
    })
    $('.collection-filters-drawer-facets').html(content)
    initFiltersClicks()

  }
  /**
   * 
   * @returns {void}
   */
  function initFiltersClicks() {
    $('.filter-group-header').off()
    $('.filter-group-clear.active').off()
    $('.collection-container input[type=checkbox]').off()
    $('.filter-group-header').click(function () {
      const el = $(this)
      el.toggleClass("is-open");
      const scrollContent = el.closest('.filter-group').find('.scroll-content')
      scrollContent.toggleClass("shown")
      if (el.hasClass('is-open')) {
        state.lastOpened.push(el.data()?.name)
      } else {
        state.lastOpened = state.lastOpened.filter(v => v !== el.data()?.name)
      }
    })
    $('.collection-container input[type=checkbox]').change(function () {
      const el = $(this)
      const { name, value } = el.data() || {}
      name === 'Color' && el.closest('.color-option').find('.value-label')?.toggleClass("active-label")
      if (el.is(':checked') && name && value) {
        state.selectedfilters.push([name, value])
      } else {
        state.selectedfilters = state.selectedfilters.filter(v => JSON.stringify(v) !== JSON.stringify([name, value]))
      }
      // queryBuilder()
      fetchFacets()
    })
    $('.filter-group-clear.active').click(function (e) {
      e.stopPropagation()
      const { name } = $(this).parent().parent().data() || {}
      state.selectedfilters = state.selectedfilters.filter(v => v[0]?.toLowerCase() !== name)
      // queryBuilder()
      fetchFacets()
    })

  }
  function initActiveFilters() {
    state.selectedfilters.length ? $('.reset-filters-wrapper').addClass('active') : $('.reset-filters-wrapper').removeClass('active')
    const contentHTML = state.selectedfilters.reduce((content, values) => (content + `<span class="selected-filter">
      ${values[0].replace('Print', '').replace('Lights', '').replace('_from_to', '').replace('tag_filter_0.464', 'Brand') + ': ' + values[1].replace('brand-', '')}
    </span>`), ``)
    $('#collection-filters-drawer-filterd-by').html(contentHTML)
  }
  function closeDrawer() {
    $('.filter-has-border').removeClass('active')
    $('.collection-filters-drawer').removeClass('is-active')
    $('.collection-filters-overlay').removeClass('is-active')
    $('#attentive_overlay').css('opacity', 1)
    $('html').css('overflowY', 'auto')
  }

  /**
   * 
   * @param {string} label 
   * @returns {void}
   */
  async function mounted() {
    // TODO: handle url params when found solution for facest issues app
    // ['Vendor', 'Type', 'Color', 'Size'].forEach(name=> initParams(name)) 
    const local = window.location
    const isVendorsCollection = local.pathname.split('/').pop() === 'vendors'
    const params = new URLSearchParams(local.search)
    if (isVendorsCollection && params.get('q')) {
      state.selectedfilters.push(['tag_filter_0.464', `brand-${params.get('q').toLocaleLowerCase()}`])
    }
    await initialization()
    fetchProducts()
    fetchFacets()
    initSortBy()
    // actions 
    $(window).scroll(() => {
      const el = $('.collection__content')
      const endOfPage = $(window).scrollTop() >= el.outerHeight() - (window.innerHeight*2)
      const pageCount = state.lastStoredProducts.total_p
      if (endOfPage && !state.loading && state.paginate.page_num < pageCount) {
        state.paginate.page_num++;
        state.loading = true
        fetchProducts({loadmore:true})
      }
    });
    $('.apply-filters-wrapper').click(function () {
      $('.collection-grid-products').html('')
      // generateProducts(state.lastStoredProducts.products)
      fetchProducts()
      closeDrawer()
    })
    $('.reset-filters-wrapper').click(function() {
      state.selectedfilters = []
      fetchProducts()
      fetchFacets()
      closeDrawer()
    })
    // $('.collection-filters-drawer').removeClass('opened')
    $('.collection-filters-toggle').click(function() {
      if($('#attentive_overlay')) $('#attentive_overlay').css('opacity' , '0')
      $('.collection-filters-drawer').addClass('is-active')
      $('.collection-filters-overlay').addClass('is-active')
      $('html').css('overflowY' , 'hidden')
    })
    $('.collection-filters-overlay').click(function() {
      closeDrawer()
    })
    $('.collection-filters-drawer-close').click(function() {
      closeDrawer()
    })
  }
  // mounted code source above
  mounted()

})();